import React from 'react';
import "./onboard-buy-card-style.scss";
import {useTranslation} from "react-i18next";
import OnboardHint from "../onboard-hint-component/OnboardHint";

const OnboardBuyCard = (props) => {
    const {t} = useTranslation();
    const {onClickPay, title, hint, content, payContent} = props;

    const handleOnClick = () => {
        if (onClickPay !== undefined)
            onClickPay();
    }

    return (
        <div className="onboard-buy-card">
            <div className="onboard-buy-card-row">
                <p className="onboard-buy-card-title">{title}</p>
                {(hint.title !== null || hint.desc !== null) &&
                    (<OnboardHint buyPackage sideLeft
                                  title={hint.title}
                                  content={hint.desc}/>
                    )
                }
            </div>
            <p className="onboard-buy-card-content">{content}</p>
            <div className="onboard-buy-card-obj">
                <div className="onboard-buy-card-pay-content">{payContent}</div>
                <div className="onboard-buy-card-pay-btn" onClick={() => handleOnClick()}>{t('buy')}</div>
            </div>
        </div>
    )
};

export default OnboardBuyCard;
